import styled from '@emotion/styled';

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 300px;
  width: 100%;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 24px 40px;
`;

interface ImageProps {
  imgWidth: string;
}

export const Image = styled.img<ImageProps>`
  width: ${({ imgWidth }) => imgWidth};
`;
